export const loginStyle = {
    button: 'bg-mainColor flex justify-center items-center p-3 rounded-lg cursor-pointer outline-none',
    login: 'flex justify-start items-center flex-col h-screen',
    container: 'relative w-full h-full',
    video: 'w-full h-full object-cover',
    googleContainer: 'absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0 bg-blackOverlay'
}
